import ExampleCodeBlock, {
  CodeParamType,
} from 'components/Docs/ExampleCodeBlock'

const js = `await integrationApp
  .flowInstance(parameters.FLOW_INSTANCE_ID)
  .patch({ enabled: {ENABLED} })
`

export function ToggleFlowInstanceEnabledCodeExample({
  parametersExpandedByDefault,
  afterRun,
}: {
  parametersExpandedByDefault?: boolean
  afterRun?: () => void
}) {
  return (
    <ExampleCodeBlock
      customCodes={{ js }}
      parametersExpandedByDefault={parametersExpandedByDefault}
      parameters={{
        FLOW_INSTANCE_ID: CodeParamType.FlowInstanceId,
        ENABLED: {
          type: CodeParamType.Boolean,
          default: true,
        },
      }}
      run={async ({ integrationApp, parameters }) => {
        const response = await integrationApp
          .flowInstance(parameters.FLOW_INSTANCE_ID)
          .patch({
            enabled: parameters.ENABLED ?? true,
          })

        afterRun?.()

        return response
      }}
    />
  )
}
